import React, { useContext, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { UserContext } from '../../app/layout/App';
import { Grid, Segment, Button, Form, Message, Divider } from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SemanticField from '../../app/common/form/SemanticField';

const SignIn = (props) => {
  let history = useHistory();
  const { dispatch } = useContext(UserContext);
  const [authError, setAuthError] = useState('');

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("L'email est invalide")
      .required("L'email est obligatoire"),
    password: Yup.string().required('Le mot de passe est obligatoire'),
  });

  return (
    <Grid>
      <Grid.Row centered>
        <Grid.Column width={6}>
          <Segment.Group>
            <Segment attached='top'>
              <h5>Connexion</h5>
            </Segment>
            <Segment attached='bottom'>
              <Formik
                initialValues={{ email: '', password: '' }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(true);
                  setAuthError('');
                  fetch('/api/auth/login', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      email: values.email,
                      password: values.password,
                    }),
                  })
                    .then(async (res) => {
                      const data = await res.json();
                      if (!res.ok) throw new Error(data.message || 'Erreur de connexion');
                      return data;
                    })
                    .then((data) => {
                      dispatch({ type: 'LOGIN', payload: data });
                      history.push('/map');
                    })
                    .catch((error) => {
                      setAuthError(error.message);
                      setSubmitting(false);
                    });
                }}
              >
                {({ dirty, isValid, handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    {authError && (
                      <Message info>
                        <Message.Header>Oups...</Message.Header>
                        <p>{authError}</p>
                      </Message>
                    )}
                    <SemanticField
                      label='Email'
                      name='email'
                      component={Form.Input}
                    />
                    <SemanticField
                      label='Mot de passe'
                      name='password'
                      type='password'
                      component={Form.Input}
                    />
                    <div>
                      <Button
                        primary
                        content='Se connecter'
                        type='submit'
                        disabled={isSubmitting || !isValid || !dirty}
                        loading={isSubmitting}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
              <Divider />
              <div style={{ textAlign: 'center' }}>
                <Button basic as={Link} to='/contact' content='No account? Join the network' />
              </div>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default SignIn;
